export default (state = [], action) => {
  switch (action.type) {
    case "FETCH_MARKETS_INREGION":
      return action.payload;
    default:
      return state;
  }
};
